import configs from 'configs'

const BaseUrlAPI = configs.apiBaseUrl

// Configs
export const GET_SOCIETIES = `${BaseUrlAPI}/api/listSocieties`
export const GET_ROLES = `${BaseUrlAPI}/api/listRoles`

// Auth
export const LOGIN = `${BaseUrlAPI}/api/login`
export const REGISTER = `${BaseUrlAPI}/api/register`
export const FORGOT_PASSWORD = `${BaseUrlAPI}/api/forgetPassword`
export const VERIFY_RESET_PASSWORD_OTP = `${BaseUrlAPI}/api/verifyOTP`
export const RESET_PASSWORD = `${BaseUrlAPI}/api/resetPassword`
export const LOGOUT = `${BaseUrlAPI}/api/logout`

// Profile
export const GET_PROFILE_DETAIL = `${BaseUrlAPI}/api/getProfileDetail`
export const UPDATE_PROFILE = `${BaseUrlAPI}/api/updateProfile`
export const UPDATE_PASSWORD = `${BaseUrlAPI}/api/updatePassword`

// Users
export const GET_USERS = `${BaseUrlAPI}/api/listUsers`
export const GET_PENDING_USERS = `${BaseUrlAPI}/api/listPendingUsers`
export const DELETE_USER = `${BaseUrlAPI}/api/deleteUser`
export const CREATE_USER = `${BaseUrlAPI}/api/addUser`
export const GET_USER_DETAIL = `${BaseUrlAPI}/api/editUser`
export const UPDATE_USER = `${BaseUrlAPI}/api/updateUser`
export const UPDATE_USER_STATUS = `${BaseUrlAPI}/api/changeUserStatus`
export const BLOCK_UNBLOCK_USER = `${BaseUrlAPI}/api/userBlockUnblock`
export const UPDATE_USER_ACCESS = `${BaseUrlAPI}/api/userBlockUnblock`
export const UPDATE_QR_EXPIRY = `${BaseUrlAPI}/api/updateQrCodeExpiry`

// Society Structure
export const UPLOAD_SOCIETY_STRUCTURE = `${BaseUrlAPI}/api/uploadSocietyStructure`
export const GET_PROPERTIES_LIST = `${BaseUrlAPI}/api/getAllProperties`
export const DELETE_PROPERTY = `${BaseUrlAPI}/api/deleteProperty`

// Get State
export const GET_STATES = `${BaseUrlAPI}/api/getStates`
// Get City
export const GET_CITIES = `${BaseUrlAPI}/api/getCities`

// Society
export const GET_SOCIETIES_LIST = `${BaseUrlAPI}/api/listSocieties`
export const DELETE_SOCIETY = `${BaseUrlAPI}/api/deleteSociety`
export const CREATE_SOCIETY = `${BaseUrlAPI}/api/addSociety`
export const GET_SOCIETY_DETAIL = `${BaseUrlAPI}/api/editSociety`
export const UPDATE_SOCIETY = `${BaseUrlAPI}/api/updateSociety`

// Announcements
export const GET_ANNOUNCEMENTS_LIST = `${BaseUrlAPI}/api/listAnnouncements`
export const DELETE_ANNOUNCEMENT = `${BaseUrlAPI}/api/deleteAnnouncement`
export const CREATE_ANNOUNCEMENT = `${BaseUrlAPI}/api/addAnnouncement`
export const GET_ANNOUNCEMENT_DETAIL = `${BaseUrlAPI}/api/getAnnouncement`
export const UPDATE_ANNOUNCEMENT = `${BaseUrlAPI}/api/updateAnnouncement`

// Family Members
export const GET_FAMILY_MEMBERS_LIST = `${BaseUrlAPI}/api/listFamilyMembers`
export const DELETE_FAMILY_MEMBER = `${BaseUrlAPI}/api/deleteFamilyMember`
export const CREATE_FAMILY_MEMBER = `${BaseUrlAPI}/api/addFamilyMember`
export const GET_FAMILY_MEMBER_DETAIL = `${BaseUrlAPI}/api/getFamilyMember`
export const UPDATE_FAMILY_MEMBER = `${BaseUrlAPI}/api/updateFamilyMember`

// Vehicles
export const GET_VEHICLES_LIST = `${BaseUrlAPI}/api/listVehicles`
export const DELETE_VEHICLE = `${BaseUrlAPI}/api/deleteVehicle`
export const CREATE_VEHICLE = `${BaseUrlAPI}/api/addVehicle`
export const GET_VEHICLE_DETAIL = `${BaseUrlAPI}/api/getVehicle`
export const UPDATE_VEHICLE = `${BaseUrlAPI}/api/updateVehicle`

// Emergency Contacts
export const GET_EMERGENCY_CONTACTS_LIST = `${BaseUrlAPI}/api/listEmergencyContacts`
export const DELETE_EMERGENCY_CONTACT = `${BaseUrlAPI}/api/deleteEmergencyContact`
export const CREATE_EMERGENCY_CONTACT = `${BaseUrlAPI}/api/addEmergencyContact`
export const GET_EMERGENCY_CONTACT_DETAIL = `${BaseUrlAPI}/api/getEmergencyContact`
export const UPDATE_EMERGENCY_CONTACT = `${BaseUrlAPI}/api/updateEmergencyContact`

// Visitors
export const GET_VISITOR_LOGS_LIST = `${BaseUrlAPI}/api/listVisitorLogs`
export const GET_VISITOR_QR_LIST = `${BaseUrlAPI}/api/listPendingQrCodes`
export const GET_VISITORS_LIST = `${BaseUrlAPI}/api/listVisitors`
export const UPDATE_VISITOR_QR_PRINTED = `${BaseUrlAPI}/api/qrCodePrinted`

// Invoices
export const GET_INVOICES_LIST = `${BaseUrlAPI}/api/getUserInvoices`
export const DELETE_INVOICE = `${BaseUrlAPI}/api/deleteInvoice`
export const CREATE_INVOICE = `${BaseUrlAPI}/api/addInvoice`
export const GET_INVOICE_DETAIL = `${BaseUrlAPI}/api/getInvoiceDetail`
export const UPDATE_INVOICE = `${BaseUrlAPI}/api/updateInvoice`

// Occupants
export const SEARCH_OCCUPANTS = `${BaseUrlAPI}/api/searchResident`

// Permissions
export const GET_MODULES = `${BaseUrlAPI}/api/listModules`
export const GET_USER_PERMISSIONS = `${BaseUrlAPI}/api/listPermissions`
export const UPDATE_USER_PERMISSIONS = `${BaseUrlAPI}/api/updateModule`

// Complaints
export const GET_COMPLAINTS_LIST = `${BaseUrlAPI}/api/listResidentComplaints`
export const DELETE_COMPLAINT = `${BaseUrlAPI}/api/deleteResidentComplaint`
export const CREATE_COMPLAINT = `${BaseUrlAPI}/api/addResidentComplaint`
export const GET_COMPLAINT_DETAIL = `${BaseUrlAPI}/api/getResidentComplaint`
export const UPDATE_COMPLAINT = `${BaseUrlAPI}/api/updateResidentComplaint`
export const ADD_COMPLAINT_IMAGE = `${BaseUrlAPI}/api/updateComplaintImage`
export const ASSIGN_COMPLAINT = `${BaseUrlAPI}/api/AssignComplain`
export const REPLY_COMPLAINT = `${BaseUrlAPI}/api/updateTechnicianComplaint`

// Complaint Types
export const GET_COMPLAINT_TYPES_LIST = `${BaseUrlAPI}/api/listComplaintTypes`

// Technicians
export const GET_ALL_TECHNICIANS_LIST = `${BaseUrlAPI}/api/techniciansList`

// VENDOR
export const GET_ALL_VENDOR_LIST = `${BaseUrlAPI}/api/listVendors`

// Ads
export const GET_ADS_LIST = `${BaseUrlAPI}/api/listAds`
export const DELETE_AD = `${BaseUrlAPI}/api/deleteAd`
export const Get_AD_Categoires = `${BaseUrlAPI}/api/getAdCategories`
export const CREATE_AD = `${BaseUrlAPI}/api/addAd`
export const GET_AD_DETAIL = `${BaseUrlAPI}/api/getAd`
export const UPDATE_AD = `${BaseUrlAPI}/api/updateAd`
export const ADD_AD_IMAGE = `${BaseUrlAPI}/api/addAdImages`
export const DELETE_AD_IMAGE = `${BaseUrlAPI}/api/deleteAdImage`

// Emails
export const SEND_MAIL_TO_USER = `${BaseUrlAPI}/api/sendEmailToUser`
export const GET_EMAILS_LIST = `${BaseUrlAPI}/api/listEmails`

// Push Notifications
export const SEND_NOTIFICATION_TO_USER = `${BaseUrlAPI}/api/notifyUsers`
export const GET_PUSH_NOTIFICATIONS_LIST = `${BaseUrlAPI}/api/listNotifications`

// Dashboard
export const GET_DASHBOARD_COUNTS = `${BaseUrlAPI}/api/dashboardCounts`
export const GET_DASHBOARD_USERS = `${BaseUrlAPI}/api/dashboardUsers`
export const GET_DASHBOARD_VISITORS = `${BaseUrlAPI}/api/dashboardVisitorUsers`
export const GET_DASHBOARD_INVOICES = `${BaseUrlAPI}/api/dashboardInvoices`
export const GET_DASHBOARD_ACTIVITIES = `${BaseUrlAPI}/api/dashboardActivities`
export const GET_DASHBOARD_NOTIFICATIONS = `${BaseUrlAPI}/api/dashboardNotifications`
export const GET_DASHBOARD_SOCIETIES_COUNT = `${BaseUrlAPI}/api/getTotalActiveSocieties`
export const GET_CITY_SOCIESTIES = `${BaseUrlAPI}/api/getCitySocieties`
export const GET_AGE_GROUP = `${BaseUrlAPI}/api/getAgeGroup`

export const GET_BRANDADS_LIST = `${BaseUrlAPI}/api/listBrandAds`
export const DELETE_BRANDAD = `${BaseUrlAPI}/api/deleteBrandAd`
export const CREATE_BRANDAD = `${BaseUrlAPI}/api/addBrandAd`
export const GET_BRANDAD_DETAIL = `${BaseUrlAPI}/api/getBrandAd`
export const UPDATE_BRANDAD = `${BaseUrlAPI}/api/editBrandAd`
export const GET_BRAND_OPTIONS = `${BaseUrlAPI}/api/listBrands`

// Brands New Apis
export const GET_BRANDS_LIST = `${BaseUrlAPI}/api/listBrands`
export const CREATE_BRAND = `${BaseUrlAPI}/api/addBrand`
export const GET_BRAND_DETAIL = `${BaseUrlAPI}/api/getBrand`
export const UPDATE_BRAND = `${BaseUrlAPI}/api/updateBrand`
export const Delete_BRAND = `${BaseUrlAPI}/api/deleteBrand`

// Survey

export const GET_SURVEY_LIST = `${BaseUrlAPI}/api/listSurveys`
export const GET_SURVEY_ANSWER_LIST = `${BaseUrlAPI}/api/listSurveyAnswers`
export const CREATE_SURVEY = `${BaseUrlAPI}/api/addSurvey`
export const GET_SURVEY_DETAIL = `${BaseUrlAPI}/api/getSurvey`
export const UPDATE_SURVEY = `${BaseUrlAPI}/api/updateSurvey`
export const DELETE_SURVEY = `${BaseUrlAPI}/api/deleteSurvey`
export const VIEW_SURVEY = `${BaseUrlAPI}/api/getSurveyResult`
export const EXPORT_SURVEY_CSV = `${BaseUrlAPI}/api/exportSurveyAnswersCsv`
export const GET_SURVEY_CHARTS_DATA = `${BaseUrlAPI}/api/getSurveyChartsData`

//tickets

export const GET_TICKETS_LIST = `${BaseUrlAPI}/api/listTickets`
export const CREATE_TICKET = `${BaseUrlAPI}/api/addTickets`
export const GET_TICKET_DETAIL = `${BaseUrlAPI}/api/getTicket`
export const UPDATE_TICKET = `${BaseUrlAPI}/api/updateTicket`
export const DELETE_TICKET = `${BaseUrlAPI}/api/deleteTicket`
export const LIST_COMMENT = `${BaseUrlAPI}/api/listComments`
export const ADD_COMMENT = `${BaseUrlAPI}/api/addComments`

// services category
// listServiceCategories   post
// addServiceCategory    post
// getServiceCategory    get
// updateServiceCategory  post
// deleteServiceCategory    delete

export const GET_SERVICE_CATEGORY_LIST = `${BaseUrlAPI}/api/listServiceCategories`
export const CREATE_SERVICE_CATEGORY = `${BaseUrlAPI}/api/addServiceCategory`
export const GET_SERVICE_CATEGORY_DETAIL = `${BaseUrlAPI}/api/getServiceCategory`
export const UPDATE_SERVICE_CATEGORY = `${BaseUrlAPI}/api/updateServiceCategory`
export const DELETE_SERVICE_CATEGORY = `${BaseUrlAPI}/api/deleteServiceCategory`

//SERVICE
export const GET_VENDOR_SERVICE_LIST = `${BaseUrlAPI}/api/listVendorServices`
export const GET_SERVICE_CATEGORIES = `${BaseUrlAPI}/api/listCategories`
export const GET_VENDOR_LIST = `${BaseUrlAPI}/api/listVendors`
export const CREATE_VENDOR_SERVICE = `${BaseUrlAPI}/api/addVendorService`
export const GET_VENDOR_SERVICE_DETAIL = `${BaseUrlAPI}/api/getVendorService`

export const UPDATE_VENDOR_SERVICE = `${BaseUrlAPI}/api/updateVendorService`
export const DELETE_VENDOR_SERVICE = `${BaseUrlAPI}/api/deleteVendorService`
export const ADD_VENDOR_SERVICE_IIMAGES = `${BaseUrlAPI}/api/addVendorServiceImages`
export const DELETE_VENDOR_SERVICE_IMAGES = `${BaseUrlAPI}/api/deleteVendorServiceImage`
export const LIST_OCCUPANTS_SERVICE_DETAILS = `${BaseUrlAPI}/api/listServiceVendors`

//  Vendor Bookings
export const GET_VENDOR_BOOKING_LIST = `${BaseUrlAPI}/api/listVendorBookings`
export const GET_BOOKING_DETAIL = `${BaseUrlAPI}/api/getBookingDetail`
export const UPDATE_BOOKING_STATUS = `${BaseUrlAPI}/api/changeServiceStatusVendor`

//  Panic Queries
export const GET_PANIC_QUERIES_LIST = `${BaseUrlAPI}/api/listPanicQuery`
